






























import { defineComponent, PropType, onMounted, reactive } from '@vue/composition-api';
import OlbIcon from '../icon/icon.vue';

/**
 * Reusable stepper component.
 */
export default defineComponent({
	props: {
		steps: {
			type: Array as PropType<Array<string>>,
			required: true,
			default: [],
		},
	},
	components: {
		OlbIcon,
	},
	setup(props) {
		const state = reactive({
			currentStep: 1,
			stepAmount: 0,
		});

		function setStep(step: number) {
			// check that the given step doesn't exceed the valid amount of steps
			// --> highest step is stepAmount - 1
			if (step > state.stepAmount || step < 1) {
				console.error(
					`[Stepper] The handed step exceeds the allowed steps. Max. step: ${state.stepAmount -
						1}, min. step: 0. Given step: ${step}`,
				);
				return;
			}
			state.currentStep = step;
		}

		function handleStepStates(stepIndex: number) {
			setStep(stepIndex);
		}

		function nextStep() {
			setStep(state.currentStep + 1);
		}

		function previousStep() {
			setStep(state.currentStep - 1);
		}

		onMounted(() => {
			// initialize amount of steps
			state.stepAmount = props.steps.length;
		});

		return { state, setStep, nextStep, previousStep, handleStepStates };
	},
});
